module.exports = __webpack_public_path__ + "93c76cf67151742388692c8c0c50eb2d.svg";